export enum EInvoiceFormat {
  ZUG_FE_RD = 'ZUG_FE_RD',
  X_RECHNUNG_CII = 'X_RECHNUNG_CII',
  PDF = 'PDF',
  X_RECHNUNG_UBL = 'X_RECHNUNG_UBL',
}
